import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useDeleteFlightGroup = () => {
	const queryClient = useQueryClient()

	return useMutation<void, Error, { tripId: string; flightGroupId: number }>({
		mutationFn: async ({ tripId, flightGroupId }) => {
			await api.delete(`/trips/${tripId}/flights/flightGroups/${flightGroupId}`)
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.flights(variables.tripId) })
		},
	})
}
